var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{attrs:{"type":_vm.type,"size":_vm.size,"native-type":_vm.nativeType,"loading":_vm.loading,"disabled":_vm.disabled,"square":_vm.square,"round":_vm.round},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4412ab43","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseButton.vue
// module id = null
// module chunks = 